import { reactive } from 'vue'

/**
 * 全局轻量消息提示（替代未实现的 this.$message）
 * 用法：this.$message.success('保存成功') / .error / .warning / .info
 */
const state = reactive({
  items: []
})

let seed = 0

function remove(id) {
  const index = state.items.findIndex(item => item.id === id)
  if (index !== -1) {
    state.items.splice(index, 1)
  }
}

function push(text, type, duration) {
  const id = ++seed
  state.items.push({ id, text, type })
  if (duration > 0) {
    setTimeout(() => remove(id), duration)
  }
  return id
}

const toast = {
  state,
  success(text, duration = 2600) {
    push(text, 'success', duration)
  },
  error(text, duration = 3200) {
    push(text, 'error', duration)
  },
  warning(text, duration = 3000) {
    push(text, 'warning', duration)
  },
  info(text, duration = 2600) {
    push(text, 'info', duration)
  },
  remove
}

export default toast
